import s from './GiftItem.module.sass';

import { FC } from 'react';

import { CurrencyEnum, GiftModel, GiftType } from '$store/models';
import { classNames, formatCurrency } from '$utils';
import { Button, LottieIcon } from '$uikit';
import { useTranslator } from '$hooks';

export const GiftItem: FC<{ gift: GiftModel; full?: boolean; onClick: () => void }> = ({
  gift,
  onClick,
  full = false,
}) => {
  const t = useTranslator();

  function renderGift() {
    if (gift.type === GiftType.Static) {
      return (
        <div
          className={s.gift}
          style={{
            backgroundImage: `url(${gift.url})`,
          }}
        />
      );
    } else if (gift.type === GiftType.Animated) {
      return (
        <div
          className={s.gift}
          style={{
            backgroundImage: `url(${gift.url})`,
          }}
        >
          <LottieIcon name={gift.url} loop className={s.lottieGift} />
        </div>
      );
    }
  }

  return (
    <div
      className={classNames({
        [s.wrap]: true,
        [s.full]: full,
      })}
    >
      <div className={s.in} onClick={onClick}>
        {renderGift()}
        {!full && (
          <div className={s.price}>{formatCurrency(gift.price, CurrencyEnum.EUR)}</div>
        )}
        {!full && (
          <Button size="small" mode="light">
            {t('send_button')}
          </Button>
        )}
      </div>
    </div>
  );
};
